import RawTextField from './components/RawTextField.js';
import React__default from 'react';
import omit from 'lodash.omit';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EmailField = function EmailField(props) {
  return /*#__PURE__*/React__default.createElement(RawTextField, _extends({}, props, {
    type: "email"
  }));
};

EmailField.Sizes = RawTextField.Sizes;
EmailField.propTypes = omit(RawTextField.propTypes, ['type', 'isMultiline']);
EmailField.defaultProps = RawTextField.defaultProps;

export { EmailField as default };
